import { Icon } from "@msuite/ui/icons";
import { moment } from "@msuite/utils/date";
import type { Enums, Nullable } from "@msuite/utils/types";
import { AttendanceCardSource } from "./attendance-card-source";

/** Props Interface */
interface AttendanceCardTimeProps {
	variant: "start" | "end";
	time: Nullable<string>;
	source: Nullable<Enums<"attendanceSource">>;
}

/**
 * One end of an attendance: when it happened and what booked it.
 *
 * The clock is read to the minute. A check-in's seconds are an artefact of when the request landed
 * rather than anything the reader decides on, and three figures of it crowd the row that carries
 * the day's actual answer.
 */
export function AttendanceCardTime({ variant, time, source }: AttendanceCardTimeProps) {
	/** Computed */
	const isStart = variant === "start";

	/** Render */
	return (
		<div className="v-stack gap-0.5 min-w-0">
			<div className="h-stack">
				<Icon
					name={isStart ? "ArrowRightFromLine" : "ArrowLeftToLine"}
					className={isStart ? "stroke-emerald-500" : "stroke-red-500"}
				/>
				<p className="font-medium tabular-nums">{time ? moment(time).getTime("HH:mm") : "--"}</p>
			</div>
			<AttendanceCardSource source={source} />
		</div>
	);
}
